import { memo, useEffect } from 'react';
import { useChatStoreRef } from '../../Chat/hooks/ChatStore.hooks';
import { useEventBus } from '.';

function ChatEventHandler() {
  const chatStoreRef = useChatStoreRef();
  const eventBus = useEventBus();

  useEffect(() => {
    const subscription = eventBus.on('chat:reset').subscribe(() => {
      const chatStore = chatStoreRef.current.getState();
      chatStore.setResponses([]);
    });
    return () => {
      subscription.unsubscribe();
    };
  }, [eventBus, chatStoreRef]);

  return null;
}

export default memo(ChatEventHandler);
